import { ModalService } from '@/app/core/services/modal.service';
import { Component, inject } from '@angular/core';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'c-dialog',
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.css',
  providers: [ConfirmationService],
  standalone: false,
})
export class DialogComponent {
  private readonly confirmationService = inject(ConfirmationService);
  message = '';
  dialogHeader = '';

  /**
   * @description Show cancel button
   */
  cancelButton!: boolean;

  /**
   * @description Show confirm action dialog
   * @param fx Alternative function
   * @param message Message of the dialog
   * @param header Header of the dialog
   */
  confirm(message: string, header: string, fx?: Function, cancelFx?: Function) {
    this.dialogHeader = header;
    this.message = message;
    this.modalService.changeVisible(true);
    this.cancelButton = true;

    this.fx = fx;
    this.cancelFx = cancelFx;
    this.confirmationService.confirm({
      message: message,
      header: header,
      icon: 'pi pi-exclamation-triangle',
    });
  }

  // private component!: ComponentRef<any>;

  /**
   * @description Stop loading screen and send success message
   */
  stop(message: string, header: string, fx?: Function, error?: boolean) {
    this.dialogHeader = header;
    this.message = message;
    this.modalService.changeVisible(true);
    setTimeout(() => {
      this.cancelButton = false;
      this.success(message, header, fx!, error);
    }, 300);
  }

  /**
   * @description Show success action dialog
   * @param fx Alternative function
   * @param message Message of the dialog
   * @param header Header of the dialog
   */
  success(message: string, header: string, fx?: Function, error?: boolean) {
    this.dialogHeader = header;
    this.message = message;
    this.modalService.changeVisible(true);
    this.cancelButton = false;

    this.fx = fx;
    this.cancelFx = fx;

    this.confirmationService.confirm({
      message: message,
      header: header,
      icon: !error ? 'pi pi-check' : 'pi pi-exclamation-triangle',
    });
  }

  private readonly modalService = inject(ModalService);
  close() {
    this.message = '';
    this.dialogHeader = '';
    this.modalService.changeVisible(false);
  }

  cancelFx!: Function | undefined;
  fx!: Function | undefined;

  onAccept() {
    this.fx && this.fx();
    this.confirmationService.close();
    this.close();
  }
  onReject() {
    this.cancelFx && this.cancelFx();
    this.confirmationService.close();
    this.close();
  }
}
